// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1jAmU","content":"RecentSearches_content__1NJlf"};